import React from 'react';
import { AlertCircle } from 'react-feather';
import RetryButton from 'components/Practice/shared/RetryButton';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const TryAgain = ({ disabled, className, handleRetry }) => {
  return (
    <div className={`d-f ${className}`}>
      <AlertCircle className="c-error mr-4 as-c" size="16" />
      <Text
        className="d-f ai-c c-error mr-4"
        variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
      >
        {t('beta_feedback.error_submitting')}
      </Text>
      <RetryButton
        onClick={handleRetry}
        disabled={disabled}
        className="c-gray-dark"
      />
    </div>
  );
};

export default TryAgain;
